import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DeleteCandidateDocumentComponent } from './delete-candidate-document.component';

@NgModule({
  declarations: [DeleteCandidateDocumentComponent],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [DeleteCandidateDocumentComponent],
  entryComponents: [DeleteCandidateDocumentComponent]
})
export class DeleteCandidateDocumentModule { }
